<template>
    <div id="nilai-reagen-create">
      <div class="vx-row">
        <div class="vx-col w-full mt-2">
          <vx-card class="mb-base" title="Form Ruangan">
            <vue-form-generator
              tag="div"
              :schema="schema"
              :model="model"
              :options="formOptions"
              @model-updated="listen"
            ></vue-form-generator>
          </vx-card>
        </div>
      </div>
      <div class="vx-col w-full" vs-justify="center">
        <vs-row vs-w="12" vs-type="flex" vs-justify="center">
          <vs-button
            class="mr-4 mb-4"
            color="danger"
            @click="$router.go(-1)"
            >
            Batal
          </vs-button>
          <vs-button
            class="mr-4 mb-4"
            icon-pack="feather"
            color="#6488e4"
            @click="onConfirm"
            >
            Simpan
          </vs-button>
        </vs-row>
  		</div>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import lab from "@/api/lab";
import master from "@/api/master";
import form from "@/api/form";
import tool from "@/tool/form_tool";
import moment from 'moment';

export default {
  components: {
      Datepicker
  },
  data() {
    return {
			model: {},
			schema: {
				fields: []
			},
			formOptions: {
				validateAfterLoad: true,
				validateAfterChanged: true,
				validateAsync: true
      },
      id: null,
    };
  },
  methods: {
		listen(newVal, schema) {
		},
    onConfirm() {
        this.$vs.dialog({
            type: 'confirm',
            color: 'warning',
            title: `Konfirmasi`,
            text: 'Anda yakin untuk menyimpan data ini ?',
            acceptText: 'Ya',
            cancelText: 'Tidak',
            accept: this.saveData
        })
    },
    saveData() {
      this.loading = true;
			let config = {
				headers: {
					"content-type": "application/json"
				}
      };

			master.saveWard(this.model, config)
				.then(res => {
					if (res.data.status) {
						this.$vs.notify({
							title: "Info",
							time: 3000,
							text: "Data telah berhasil di submit",
							color: "success",
							position: "top-right"
						});
						this.$router.push(
							"/lab/ruangan/list"
						);
					} else {
						this.$vs.notify({
							title: "Terjadi Kesalahan",
							time: 3000,
							text: res.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				})
				.catch(error => {
					if (error.response) {
						this.$vs.notify({
							title: "An Error Occured",
							time: 3000,
							text: error.response.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				});

		},
		async firstLoad() {
			const frm = await form.getFormRuangan();
			this.schema.fields = frm.data.data[0].fields;
			let idx = this.$route.params.id;
			if (idx) {
        let n = {id: idx};
				const xmodel = await master.getWardV2(n);
        this.model = xmodel.data.data[0];
        this.id = idx;
			} else {
				this.model = frm.data.data[0].model;
      }
    },
  },
  computed: {
  },
  mounted() {
  },
  created() {
    this.firstLoad();
  }
};
</script>
